import { FooterRoot } from 'components/Footer/Footer.styles'
import { Stack } from 'components/Stack'
import { Text } from 'components/Text'
import { TextInputRoot } from 'components/TextInput/TextInput.styles'
import { styled } from 'stitches.config'

export const AllProductsRoot = styled('div', {
  '&': {
    [`${FooterRoot}`]: {
      borderTop: '12px solid transparent',
      borderBottom: 0,
      borderImage: 'url(/assets/pattern-footer-border-mobile.svg) 30',

      '@bp2': {
        borderImage: 'url(/assets/pattern-footer-border-desktop.svg) 30',
      },
    },
  },
})

export const Wrapper = styled('div', {
  padding: '$2 $3',
  backgroundColor: '$secondary-100',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '$5',
  backgroundImage: 'none',

  '@bp2': {
    backgroundImage: 'url(assets/pattern-all-products-01.png)',
    backgroundSize: '40%',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'left 150vh',
    padding: '$8 $8 $15 $8',
  },
})

export const SectionHeader = styled(Stack, {
  display: 'none',

  '@bp2': {
    display: 'flex',
    alignItems: 'center',

    '&': {
      [`${Text}:first-child`]: {
        minWidth: '240px',
      },
      [`${Text}:last-child`]: {
        maxWidth: '888px',
      },
    },
  },
})

export const SectionBody = styled('div', {
  display: 'flex',
  flexDirection: 'column',

  '@bp2': {
    width: '100%',
    maxWidth: '$max',
    flexDirection: 'row',
    justifyContent: 'center',
    gap: '$2',
  },
})

export const MenuWrapper = styled(Stack, {
  display: 'none',

  '@bp2': {
    display: 'flex',
    width: '280px',
    flexShrink: 0,
  },
})

export const SearchWrapper = styled('div', {
  '&': {
    [`${TextInputRoot}`]: {
      boxShadow: '0px 4px 0px $colors$secondary-600',
    },
  },
})

export const Results = styled('div', {
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: '$5',
  backgroundColor: '$accent-white',
  padding: '$3 $3',
  border: '1px solid $secondary-600',
  borderRadius: '$4',
  boxShadow: '0px 3px 0px $colors$secondary-600',
  marginBottom: '$10',

  '@bp2': {
    padding: '$3 $4 $10',
    gap: '$7',
    marginBottom: '0',
  },
})

export const EmptyStateWrapper = styled('div', {
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  py: '$12',
})
